import FindLangKey from "Global/Functions/FindLangKey/FindLangKey";

export const dictionary = () => {
  const freezeType = FindLangKey("freeze-contracts-label-freeze-type");
  const startDate = FindLangKey("freeze-contracts-label-contract-start-date");
  const stopDate = FindLangKey("freeze-contracts-label-contract-end-date");
  const owePrice = FindLangKey("freeze-contracts-label-owe-price");
  return {
    freezeType,
    startDate,
    stopDate,
    owePrice,
  };
};
